// S-20 - Profile
import { useTranslation } from "react-i18next";

import { PageHeader } from "../components/ui/PageHeader";
import { useAuth } from "../context/AuthContext";
import { naturalCompare } from "../utils/natural-sort";

export function ProfilePage() {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const level = user.accessLevel ?? 0;
  const roleLabel =
    level >= 100 ? t("role_admin") : level >= 50 ? t("role_manager") : t("role_expert");

  return (
    <div className="sm-page">
      <PageHeader title={t("nav_profile")} subtitle={user.email} />

      <div className="sm-card sm-card-pad">
        <dl className="sm-dl">
          <dt className="sm-muted">{t("full_name")}</dt>
          <dd>{user.fullName}</dd>
          <dt className="sm-muted">{t("matricule")}</dt>
          <dd>{user.internalId}</dd>
          <dt className="sm-muted">{t("email_label")}</dt>
          <dd>{user.email}</dd>
          <dt className="sm-muted">{t("role")}</dt>
          <dd>
            <span className="sm-badge-pill sm-badge-blue">{roleLabel}</span>
            {user.accessProfile ? ` · ${user.accessProfile}` : ""}
            {user.role ? ` · ${user.role}` : ""}
          </dd>
          <dt className="sm-muted">{t("language")}</dt>
          <dd>{user.language}</dd>
          <dt className="sm-muted">{t("domains")}</dt>
          <dd>
            {user.domains.length ? [...user.domains].sort(naturalCompare).join(", ") : "—"}
          </dd>
        </dl>
      </div>
    </div>
  );
}
